// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper--Bt++f","notfound":"notfound--D64CL"};